import { render, staticRenderFns } from "./LeadsGridContent.vue?vue&type=template&id=591a8354"
import script from "./LeadsGridContent.vue?vue&type=script&lang=ts"
export * from "./LeadsGridContent.vue?vue&type=script&lang=ts"
import style0 from "./LeadsGridContent.vue?vue&type=style&index=0&id=591a8354&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports